import React from "react";
import {
  Autocomplete,
  TextField,
  Checkbox,
  Box
} from "@mui/material";

const MultiSelect = ({
  options,
  value = [], // Default value to an empty array to handle undefined or null
  onChange,
  placeholder = "Select Options",
  icon,
  checkedIcon,
  checkboxStyles,
  textFieldStyles = {},
  style,
}) => {
  
  // Determine if all options are selected
  const allSelected = options?.length > 0 && value?.length === options?.length;

  // Handle change for options
  const handleChange = (newSelectedOptions) => {
    const selectedValues = newSelectedOptions.map((option) => option.value);
    onChange(selectedValues);
  };

  // Add "Select All" option at the beginning
  const formattedOptions = options?.length > 1 ?  [
    { value: "select_all", title: "Select All" },
    ...options,
  ] : options;

  return (
    <Box>
      <Autocomplete
        multiple
        limitTags={3}
        options={formattedOptions}
        disableCloseOnSelect
        style={style}
        value={options.filter((option) => value?.includes(option.value))}
        isOptionEqualToValue={(option, selectedOption) =>
          option.value === selectedOption.value
        }
        getOptionLabel={(option) => option.title}
        onChange={(e, newSelectedOptions) => {
          if (
            newSelectedOptions.some((option) => option.value === "select_all")
          ) {
            // Toggle "Select All"
            if (allSelected) {
              onChange([]); // Deselect all
            } else {
              onChange(options.map((option) => option.value)); // Select all
            }
          } else {
            handleChange(newSelectedOptions.filter((option) => option.value !== "select_all"));
          }
        }}
        renderOption={(props, option, { selected }) => (
          <li
            {...props}
            className={`${props?.className} dropdownCheckboxItem`}
            style={{ pointerEvents: option.disabled ? "none" : "auto" }}
          >
            <Checkbox
              sx={checkboxStyles}
              icon={icon}
              checkedIcon={checkedIcon}
              style={{ marginRight: 8 }}
              checked={
                option.value === "select_all" ? allSelected : selected
              }
              disabled={option.disabled} // Disable checkbox
            />
            {option.title}
          </li>
        )}
        renderTags={(selected) => (
          <Box sx={{ display: "flex", alignItems: "center", width: "60%" }}>
            {selected.length > 1 && (
              <Box
                sx={{
                  width: "25px",
                  height: "22px",
                  borderRadius: "50%",
                  backgroundColor: "#403E9F",
                  color: "white",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontSize: "14px",
                  marginRight: "8px",
                }}
              >
                {selected.length}
              </Box>
            )}
            <span
              className="mr-1"
              style={{
                fontFamily: "Poppins",
                width: "75%",
                whiteSpace: "noWrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                display: "block",
              }}
            >
              {selected?.length && selected[selected?.length - 1]?.title}
            </span>
          </Box>
        )}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            placeholder={placeholder}
            sx={{
              ...textFieldStyles,
              "& .MuiInputBase-input::placeholder": {
                fontSize: "14px",
              },
            }}
          />
        )}
      />
    </Box>
  );
};

export default MultiSelect;
